import styled from "styled-components"

const DirectAccess = styled.a`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  @media (max-width: 600px) {
    svg {
      path {
        fill: ${(props) => props.theme.a_color_gradients.a_dark};
      }
    }
  }
`

const CustomHeaderArrows = styled.button`
  border: none;
  background-color: white;
  border-radius: 50%;
  font-weight: bold;
  &:hover {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const SearchButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const NotificationButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const Container = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
export {
  SearchButton,
  NotificationButton,
  Container,
  DirectAccess,
  CustomHeaderArrows,
}
